<template>
  <div class="SettingsView">
    <div class="card">
      <h2>Настройка пользователя</h2>
      <p class="hint">Логин: {{ login }}</p>

      <div class="avatar-row">
        <img
          v-if="avatar"
          class="avatar"
          :src="baseUrl + 'storage/images/' + avatar"
          alt="Аватар пользователя"
        />

        <div class="avatar-actions">
          <span class="hint">Аватар: {{ avatar || "не задан" }}</span>
          <button
            class="addTitleImage"
            @click="openPickImage = true"
            type="button"
          >
            Титульное изображение
          </button>
        </div>
      </div>

      <PickGallery
        v-if="openPickImage"
        @close="openPickImage = false"
        @pickImage="pickImage"
      />

      <div class="form-actions">
        <button class="update" type="button" @click="updateUser">
          Обновить
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import users from "@/composables/views/users.ts";
import PickGallery from "@/components/gallery/PickGallery";

export default {
  setup() {
    const { getUser, login, updateUser, avatar, email, name, baseUrl } =
      users(1);
    return {
      getUser,
      login,
      updateUser,
      avatar,
      email,
      name,
      baseUrl,
    };
  },
  data() {
    return {
      openPickImage: false,
    };
  },
  components: { PickGallery },
  methods: {
    pickImage(image) {
      this.avatar = image;
      this.openPickImage = false;
    },
  },
  async created() {
    this.getUser();
  },
};
</script>
